import Vue from 'vue'
import Router from 'vue-router'
import axios from '@/assest/axios/axios';
import user_children_page from './user/_user_children.js'
import kdsuper_children_page from './kdsuper/_kdsuper_children.js'

Vue.use(Router)

const routes = [{
  path: '/',
  name: 'merchant_index',
  // component: () => import('@/views/merchant/login/login'),
  component: () => import('@/views/jdy_no_sign_in'),
  meta: {
    tpflag: 'merchant',
  },
}, {
  path: '/wechat_auth',
  name: 'wechat_auth',
  component: () => import('@/views/wechat/auth'),
  meta: {
    tpflag: 'merchant',
    title: '公众号授权登录页',
  },
}, {
  path: '/wechat_success',
  name: 'wechat_success',
  component: () => import('@/views/wechat/success'),
  meta: {
    tpflag: 'merchant',
  },
}, {
  path: '/user/login',
  name: 'merchant_login',
  component: () => import('@/views/merchant/login/login'),
  meta: {
    tpflag: 'merchant',
  },
}, {
  path: '/user/loginsuccess',
  name: 'merchant_loginsuccess',
  component: () => import('@/views/merchant/login/login_success'),
  meta: {
    tpflag: 'merchant',
  },
}, {
  path: '/user/register',
  name: 'merchant_register',
  component: () => import('@/views/merchant/login/register'),
  meta: {
    tpflag: 'merchant',
  },
}, {
  path: '/user/registersuccess',
  name: 'merchant_registersuccess',
  component: () => import('@/views/merchant/login/register_success'),
  meta: {
    tpflag: 'merchant',
  },
}, {
  path: '/user/find_pwd',
  name: 'merchant_find_pwd',
  component: () => import('@/views/merchant/login/find_pwd'),
  meta: {
    tpflag: 'merchant',
  },
}, {
  path: '/user/joiner_merchant',
  name: 'merchant_joiner_merchant',
  component: () => import('@/views/merchant/login/joiner_merchant'),
  meta: {
    tpflag: 'merchant',
  },
}, {
  path: '/user/create_merchant',
  name: 'merchant_create_merchant',
  component: () => import('@/views/merchant/login/create_merchant'),
  meta: {
    tpflag: 'merchant',
  },
}, {
  path: '/user',
  name: 'merchant',
  component: () => import('@/views/merchant/main'),
  meta: {
    requiresAuth: true,
    title: '快叮',
    tpflag: 'merchant',
  },
  children: user_children_page,
}, {
  path: '/kdsuper/login',
  name: 'backend_login',
  component: () => import('@/views/backend/login/login'),
  meta: {
    tpflag: 'backend',
    title: '控制台登录页',
  },
}, {
  path: '/kdsuper/loginsuccess',
  name: 'backend_loginsuccess',
  component: () => import('@/views/backend/login/login_success'),
  meta: {
    tpflag: 'backend',
  },
}, {
  path: '/kdsuper',
  name: 'backend',
  component: () => import('@/views/backend/main'),
  meta: {
    tpflag: 'backend',
    title: '控制台',
  },
  children: kdsuper_children_page
}, {
  path: '/hktlogin',
  name: 'hkt_login',
  component: () => import('@/views/hkt/login_hkt'),
  meta: {
    tpflag: 'hkt',
  },
}, {
  path: '/loginhktqwsuccess',
  name: 'login_hkt_qw_success',
  component: () => import('@/views/hkt/login_hkt_qw_success'),
  meta: {
    tpflag: 'hkt',
  },
}, {
  path: '/ywymlogin',
  name: 'ywym_login',
  component: () => import('@/views/ywym/login'),
  meta: {
    tpflag: 'ywym',
  },
}, {
  path: '/loginownsuccess',
  name: 'login_own_success',
  component: () => import('@/views/own/login_success'),
  meta: {
    tpflag: 'own',
  },
}, {
  path: '/loginownpcsuccess',
  name: 'login_ownpc_success',
  component: () => import('@/views/own/loginpc_success'),
  meta: {
    tpflag: 'own',
  },
}]

const vueRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({
    y: 0
  }),
  routes
})

vueRouter.beforeEach(function(to, from, next) {
  const nextRoute = ['merchant_login', 'merchant_register', 'merchant_find_pwd', 'merchant_loginsuccess',
    'merchant_joiner_merchant', 'merchant_create_merchant', 'merchant_registersuccess', 'backend_login',
    'backend_loginsuccess', 'backend_wechatauth', 'hkt_login', 'login_hkt_success', 'wechat_auth',
    'wechat_success', 'merchant_index'
  ];
  var merchantAccountId = localStorage.getItem("merchantAccountId"),
    adminId = localStorage.getItem("adminId"),
    channelId = localStorage.getItem("channelId"),
    merchantId = localStorage.getItem("merchantId")

  //跳转后台
  if (nextRoute.indexOf(to.name) < 0) {
    var tpflag = to.meta.tpflag,
      itemId = merchantAccountId
    //未登录
    if (tpflag == 'backend') {
      itemId = adminId
    } else if (tpflag == 'channel') {
      itemId = channelId
    }
    if (itemId == null || itemId == '') {
      if (tpflag == 'merchant') {
        vueRouter.push({
          name: 'merchant_login',
        })
      } else if (tpflag == 'backend') {
        vueRouter.push({
          name: 'backend_login',
        })
      } else {
        // vueRouter.push({
        //   name: 'channel_login',
        // })
      }
    } else {

      if (tpflag == 'merchant' && (merchantId == null || merchantId == '')) {
        vueRouter.push({
          name: 'merchant_login',
        })
      }

      axios.get('/adminapi/Login/checkLogin', {
          params: {
            tpflag: tpflag
          }
        })
        .then(function(response) {
          if (response.data.code == -1) {
            if (tpflag == 'merchant') {
              localStorage.setItem("merchantAccountId", '')
              localStorage.setItem("merchantId", '')
              vueRouter.push({
                name: 'merchant_login',
                query: {
                  otherlogin: 1
                }
              })
            } else if (tpflag == 'backend') {
              localStorage.setItem("adminId", '')
              vueRouter.push({
                name: 'backend_login',
                query: {
                  otherlogin: 1
                }
              })
            } else {
              // localStorage.setItem("channelId", '')
              // vueRouter.push({
              //   name: 'channel_login',
              //   query: {
              //     otherlogin: 1
              //   }
              // })
            }
          } else if (response.data.code == -2) {
            if (tpflag == 'merchant') {
              localStorage.setItem("merchantAccountId", '')
              localStorage.setItem("merchantId", '')
              vueRouter.push({
                name: 'merchant_login',
              })
            } else if (tpflag == 'backend') {
              localStorage.setItem("adminId", '')
              vueRouter.push({
                name: 'backend_login',
              })
            } else {
              // localStorage.setItem("channelId", '')
              // vueRouter.push({
              //   name: 'channel_login',
              // })
            }
          } else if (response.data.code == -3) {
            if (tpflag == 'merchant') {
              localStorage.setItem("merchantAccountId", '')
              localStorage.setItem("merchantId", '')
              vueRouter.push({
                name: 'merchant_login',
                query: {
                  otherlogin: 2
                }
              })
            } else if (tpflag == 'backend') {
              localStorage.setItem("adminId", '')
              vueRouter.push({
                name: 'backend_login',
                query: {
                  otherlogin: 2
                }
              })
            } else {
              // localStorage.setItem("channelId", '')
              // vueRouter.push({
              //   name: 'channel_login',
              //   query: {
              //     otherlogin: 2
              //   }
              // })
            }
          } else if (response.data.code == -4) {
            if (tpflag == 'merchant') {
              localStorage.setItem("merchantAccountId", '')
              localStorage.setItem("merchantId", '')
              vueRouter.push({
                name: 'merchant_login',
                query: {
                  otherlogin: 3,
                  merchant: response.data.data
                }
              })
            } else if (tpflag == 'backend') {
              localStorage.setItem("adminId", '')
              vueRouter.push({
                name: 'backend_login',
                query: {
                  otherlogin: 3
                }
              })
            } else {
              // localStorage.setItem("channelId", '')
              // vueRouter.push({
              //   name: 'channel_login',
              //   query: {
              //     otherlogin: 3
              //   }
              // })
            }
          } else {
            if (to.name == 'merchant') {
              vueRouter.push({
                path: '/user/desktop/b',
              })
            } else if (to.name == 'backend') {
              vueRouter.push({
                path: '/kdsuper/backlog/bj/12',
              })
            }
          }
        })
        .catch(function(error) {
          if (tpflag == 'merchant') {
            localStorage.setItem("merchantAccountId", '')
            localStorage.setItem("merchantId", '')
            vueRouter.push({
              name: 'merchant_login',
            })
          } else if (tpflag == 'backend') {
            localStorage.setItem("adminId", '')
            vueRouter.push({
              name: 'backend_login',
            })
          } else {
            // localStorage.setItem("channelId", '')
            // vueRouter.push({
            //   name: 'channel_login',
            // })
          }
          console.log('error', error);
        })
    }
  }
  //已登录的情况再去登录页，跳转至首页
  if (to.name === 'merchant_login') {
    if (merchantAccountId != null && merchantAccountId != '' && merchantId != null && merchantId != '') {
      vueRouter.push({
        path: '/user/desktop/b',
      });
    }
  } else if (to.name === 'backend_login') {
    if (adminId != null && adminId != '') {
      vueRouter.push({
        path: '/kdsuper/backlog/bj/12',
      });
    }
  }
  next();
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)

  return originalPush.call(this, location).catch(err => err)
}

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js